import { render, staticRenderFns } from "./StudentAbs.vue?vue&type=template&id=0c490b96&scoped=true"
import script from "./StudentAbs.vue?vue&type=script&lang=js"
export * from "./StudentAbs.vue?vue&type=script&lang=js"
import style0 from "./StudentAbs.vue?vue&type=style&index=0&id=0c490b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c490b96",
  null
  
)

export default component.exports